import { render, staticRenderFns } from "./MainBody.vue?vue&type=template&id=4be278d8&scoped=true&"
import script from "./MainBody.vue?vue&type=script&lang=js&"
export * from "./MainBody.vue?vue&type=script&lang=js&"
import style0 from "./MainBody.vue?vue&type=style&index=0&id=4be278d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../steam-app-cms-prod/steam-app-cms/sources/client/fastboot-cms-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be278d8",
  null
  
)

export default component.exports